import { createStore, applyMiddleware, compose } from "redux";
import reducer from "../reducers/index";
import thunk from "redux-thunk";

import {  middleware } from "../../middleware/index";

const storeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleWares = [middleware, thunk];

const store = createStore(reducer, storeEnhancers(applyMiddleware(...middleWares)));


export default store;